import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=ed3ff764&scoped=true&"
import script from "./UploadIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UploadIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3ff764",
  null
  
)

export default component.exports